<template>
  <button
    class="button"
    @click="$emit('click')"
    @dblclick="$emit('dblclick')"
    :style="buttonStyle"
    :disabled="disabled"
  >
    <i v-if="icon" :class="icon"></i>

    <div v-if="label && label.length" class="button__text">
      {{ label }}
    </div>
    <div v-else class="button__text">
      <slot />
    </div>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    buttonStyle: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  background-color: white;
  border: 2px solid $cherry;
  padding: 5px 16px;
  border-radius: 5px;
  outline: none;
  color: $cherry;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  > i {
    width: 14px;
    margin-right: 8px;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.button__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
